import { getUploadUrl, triggerFileEmbedding, uploadFile } from '@/services/kbService';

interface Options {
  progress: (params: { process: number }) => void;
  success: (params: any) => void;
  fail: (err: Error) => void;
  begin?: (params: any) => void;
}

export async function upload(file: File, options: Options) {
  const { progress, success, fail, begin } = options;

  const responseMessage = (data: any, eventType: string) => {
    switch (eventType) {
      case 'begin':
        begin && begin(data);
        break;
      case 'fail':
        fail && fail(data);
        break;
      case 'progress':
        progress && progress(data);
        break;
      case 'success':
        success && success(data);
        break;
    }
  };

  responseMessage({}, 'begin');
  try {
    const {
      errno,
      errmsg,
      data: { url: uploadUrl, file_id  },
    } = await getUploadUrl(file.name, file.size);
    if (errno) {
      responseMessage({ message: errmsg }, 'fail');
      return;
    }

    const uploadRes = await uploadFile(uploadUrl, file);
    if (uploadRes.status !== 200) {
      responseMessage({ message: 'Failed to upload' }, 'fail');
      return
    }
    const { errno: triggerErrno, errmsg: triggerErrMsg, data: { file_url: fileUrl }} = await triggerFileEmbedding(file_id)
    if (triggerErrno) {
      responseMessage({ message: triggerErrMsg }, 'fail');
      return
    }
    responseMessage(
      { progress: 100 },
      'progress'
    );
    responseMessage(
      { file_id, name: file.name, type: file.type, size: file.size, url: fileUrl },
      'success'
    );
  } catch (err) {
    responseMessage({ message: err.toString() }, 'fail');
  }
}
